import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取厂家列表
 * */
export const getVenderListApi = () => $http.get('/couponrecharge/coupon_api/vender_list')

/**
 * 获取商品列表
 * 包含 mid 返回渠道商品列表，否则返回厂家商品列表
 * */
export const getProductListApi = (params: any) => $http.get(`/couponrecharge/coupon_api/${ params.mid ? 'channel_sku_list' : 'vender_sku_list' }`, params)

/**
 * 新增/编辑商品信息
 * 包含 mid 保存渠道商品，否则保存厂家商品
 * */
export const saveProductApi = (data: any) => $http.post(`/couponrecharge/coupon_api/${ data.mid ? 'channel_sku_save' : 'vender_sku_save' }`, data)

/**
 * 获取商品详情
 * 包含 mid 返回渠道商品列表，否则返回厂家商品列表
 * */
export const getProductDetailApi = (id: any, mid:string = '') => $http.get(`/couponrecharge/coupon_api/${ mid ? 'channel_details_info' : 'vender_details_info' }`, {id})

/**
 * 厂家商品上下架
 * id: 商品ID
 * flag: 0-下架，1-上架
 * */
export const updateProductStatusApi = (id: number | string, flag: number | string, mid:string = '') => $http.post(`/couponrecharge/coupon_api/${mid ? 'channel_sku_status' : 'vender_sku_status'}`, { id, flag })

/**
 * 获取订单列表
 * */
export const getOrderListApi = (params: object = {}) => $http.get('/couponrecharge/coupon_api/zhichong_order_list', params)

/**
 * 删除商品
 * id: 商品ID
 * */
export const delProductApi = (id: number) => $http.post('/relevance/relevance_goods_all_list', { id })